import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { WhatIsValuan } from './components/WhatIsValuan';
import { FeatureCards } from './components/FeatureCards';
import { LogoCloud } from './components/LogoCloud';
import { PricingSection } from './components/PricingSection';
import { MobileApp } from './components/MobileApp';
import { UseCases } from './components/UseCases';
import { FeaturesGrid } from './components/FeaturesGrid';
import { Footer } from './components/Footer';
import { PruebaGratuita } from './pages/PruebaGratuita';
function HomePage() {
  return <div className="min-h-screen bg-white font-sans selection:bg-valuan-blue selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <WhatIsValuan data-id="element-4" />
        <FeatureCards data-id="element-5" />
        <LogoCloud data-id="element-6" />
        <PricingSection data-id="element-7" />
        <MobileApp data-id="element-8" />
        <UseCases data-id="element-9" />
        <FeaturesGrid data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-12">
      <Routes data-id="element-13">
        <Route path="/" element={<HomePage data-id="element-15" />} data-id="element-14" />
        <Route path="/prueba-gratuita" element={<PruebaGratuita data-id="element-17" />} data-id="element-16" />
      </Routes>
    </BrowserRouter>;
}